import i18n from "../locales/index"
import request from "@/utils/request"
const baseurl = process.env.VUE_APP_BASE_URL
// 店铺列表
export function shopList() {
  return request({
    url: baseurl + "/shops",
    method: "get",
  })
}
// 店铺详情
export function shopDetail(id) {
  return request({
    url: baseurl + `/shops/${id}`,
    method: "get",
  })
}
// 店铺更新
export function shopUpdate(data) {
  return request({
    url: baseurl + `/shops/${data.id}`,
    method: "put",
    data,
  })
}
// 获取店铺广告
export function getBanners(data) {
  return request({
    url: baseurl + "/banners",
    method: "get",
    params: data,
  })
}
